import * as styled from './styles';

export default function PaymentComplete() {
  return (
    <styled.Container>
      <styled.Logo>Kudable</styled.Logo>
      <styled.Card>
        <styled.Icon>✅</styled.Icon>
        <styled.Title>Payment successful!</styled.Title>
        <styled.Subtitle>
          Your Kudable provider subscription is now active. You can close this
          page and return to the app.
        </styled.Subtitle>
        <styled.Divider />
        <styled.Hint>
          If your subscription does not reflect in the app within a few minutes,
          please contact support.
        </styled.Hint>
      </styled.Card>
    </styled.Container>
  );
}
